import styled from "styled-components";
import { fieldStyles, labelStyles } from "./ui";

// Renders a visible label from the placeholder text. A fragment is used so the
// input stays a direct child of the "#step" container the validator scans.
const TextBox = ({ placeholder, name, setPayload, value, errorType, errorMessage }) => {
  return (
    <>
      { placeholder && <Label htmlFor = { name }>{ placeholder }</Label> }
      <Input
        type = 'text'
        id = { name }
        name = { name }
        value = { value }
        onChange = { e => { handleChange(e, setPayload) } }
        data-error-message = { errorMessage }
        data-error-type = { errorType }
      />
    </>
  );
};

const handleChange = (e, setPayload) => {
  setPayload(e.target.name, e.target.value);
}

const Label = styled.label`
  ${labelStyles}
`;

const Input = styled.input`
  ${fieldStyles}
  margin-bottom: 16px;
`;

export default TextBox;
